import { TableColumn } from "@components/Table/TableColumns";
import { useSelectAmongContext } from "@vms/SelectAmong/SelectAmongContext";
import { useSelectFilters } from "@vms/SelectFilters/SelectFiltersContext";
import { useMemo } from "react";
import { getCopyTableData } from "@components/Table/TableUtils";

export type CopyTableOptions = {
    additionalRows?: string[][];
    hideCategories?: boolean;
    hideAmong?: boolean;
}

export function useCopyTableDataWithFilters(columnsRaw: TableColumn[], rowsCount: number, options?: CopyTableOptions) {
    const { amongCopyTableText } = useSelectAmongContext();
    const { appliedCategoryNamesData } = useSelectFilters();

    const copyTableData = useMemo(
        () => getCopyTableData(columnsRaw, rowsCount),
        [columnsRaw, rowsCount]
    );

    const appliedCategoriesText = useMemo(
        () => {
            return appliedCategoryNamesData.length
                ? appliedCategoryNamesData.map(
                    (categoryData) => {
                        return categoryData.isAllSelected ? categoryData.name : categoryData.subCategories.join(", ")
                    }).join(" | ")
                : "All"
        },
        [appliedCategoryNamesData]
    );

    return useMemo(
        () => {
            let head = [
                ['Datassential Consumer Preferences'],
            ];

            if (!options?.hideCategories) {
                head.push([`Categories: ${appliedCategoriesText}`]);
            }

            if (!options?.hideAmong) {
                head.push([`Among: ${amongCopyTableText ?? ""}`]);
            }

            if (options?.additionalRows) {
                head = [
                    ...head,
                    ...(options?.additionalRows ?? []),
                ];
            }

            return [
                ...head,
                [],
                ...copyTableData
            ];
        },
        [appliedCategoriesText, amongCopyTableText, copyTableData, options]
    )
}